export default "__VITE_ASSET__63edrMtg__"